module.exports = __webpack_public_path__ + "static/pointer_cursor-fa5c54d6991424c2e5cda1f080497253.png";